"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// Constants for the Table component
var TableConstants = {
  TABLE_ALERT: {
    ERROR: 'error',
    WARNING: 'warning'
  }
};
var _default = TableConstants;
exports.default = _default;